import React from "react";
import {useSetting} from "../../contexts/setting";
import type {PixelationMask} from "../../libs/pixelationMask";

/**
 * The brush-mask buttons of one Releases template, shown while the pixelation
 * brush is on: undo the last stroke, fill (the effect everywhere, the same as
 * no mask) and clear (the effect nowhere, to paint it in). The mask is stored
 * per template in `pixelationMasks` (libs/pixelationMask.ts).
 */
const PixelMaskControl = ({id}: {id: string}) => {
  const {pixelationMasks, undoPixelationMaskStroke, fillPixelationMask} = useSetting();
  const mask: PixelationMask | undefined = pixelationMasks?.[id];
  const canUndo = !!mask?.strokes.length;
  const isFull = !mask;
  const isEmpty = !!mask && mask.base === 0 && mask.strokes.length === 0;

  return (
    <>
      <button
        type="button"
        className="checkbox pixel-mask"
        data-tooltip="Undo the last brush stroke on this banner"
        aria-label="Undo the last brush stroke on this banner"
        disabled={!canUndo}
        onClick={() => undoPixelationMaskStroke(id)}
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path
            d="M7 5L3.5 8.5 7 12"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4 8.5h7.5a4.5 4.5 0 010 9H9"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </svg>
      </button>
      <button
        type="button"
        className="checkbox pixel-mask"
        data-tooltip="Show the effect on all of this banner"
        aria-label="Show the effect on all of this banner"
        disabled={isFull}
        onClick={() => fillPixelationMask(id, 1)}
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <rect x="3" y="3" width="14" height="14" rx="2" fill="currentColor" />
        </svg>
      </button>
      <button
        type="button"
        className="checkbox pixel-mask"
        data-tooltip="Remove the effect from all of this banner, then paint it in"
        aria-label="Remove the effect from all of this banner"
        disabled={isEmpty}
        onClick={() => fillPixelationMask(id, 0)}
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <rect
            x="3.8"
            y="3.8"
            width="12.4"
            height="12.4"
            rx="1.6"
            stroke="currentColor"
            strokeWidth="1.6"
          />
        </svg>
      </button>
    </>
  );
};

export default PixelMaskControl;
